import { storePasswordCriteria } from "../../../SessionManagement/actionCreators/password"

export const mapState = (state) => ({
  passwordCriteria: state.sessionReducer.passwordCriteria,
  adminOnly: state.sessionReducer.adminOnly,
})
export const mapDispatch = (dispatch) => ({
  storePasswordCriteria: () => storePasswordCriteria(dispatch),
})
